export const collaborators = (state = {}, action) => {
  switch (action.type) {
    case 'LOAD_COLLABORATOR':
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export default collaborators;
